import { footerIcons } from "../../Constants/Constants.js";
import "./footer.scss";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-social">
        <span className="social-email">Puneetsharma997@gmail.com</span>
        <div className="f-icons">
          <a
            href="https://www.linkedin.com/in/puneetsharma997"
            target="_blank"
            rel="noopener noreferrer"
          >
            <footerIcons.Linkedin color="white" size="5rem" />
          </a>

          <a
            href="https://github.com/puneetsharma997"
            target="_blank"
            rel="noopener noreferrer"
          >
            <footerIcons.Github color="white" size="5rem" />
          </a>
        </div>

        <p className="rightsReserved">
          Made with <p className="made-with-love-icon">&nbsp;❤️&nbsp;</p> by
          Puneet Sharma
        </p>
      </div>
    </div>
  );
};

export default Footer;
